import { APICallV3Post } from 'reactApp/api/APICall';
import { discountInOutflowValue } from 'reactApp/appHelpers/featuresHelpers/features/discountInOutflow';

export interface SubscriptionDiscountAPICallResponse {
    result: 'fail' | 'success';
    discount_price?: number;
    discount_percent?: number;
    sub_id?: number;
}

export interface SubscriptionDiscountQueryParams {
    sub_id: string | number;
    discount_percent?: 30 | 50;
    action?: 'set';
}

export class SubscriptionDiscountAPICall extends APICallV3Post<SubscriptionDiscountAPICallResponse, SubscriptionDiscountQueryParams> {
    _method = 'billing/subscription/discount';
}

export const checkSubscriptionDiscount = (sub_id: string | number) =>
    new SubscriptionDiscountAPICall().makeRequest({ sub_id, discount_percent: discountInOutflowValue });

export const setSubscriptionDiscount = (sub_id: string | number) =>
    new SubscriptionDiscountAPICall().makeRequest({ sub_id, action: 'set', discount_percent: discountInOutflowValue });
